import { render, staticRenderFns } from "./ViewMovementsField.vue?vue&type=template&id=31c59304&scoped=true&"
import script from "./ViewMovementsField.vue?vue&type=script&lang=js&"
export * from "./ViewMovementsField.vue?vue&type=script&lang=js&"
import style0 from "./ViewMovementsField.vue?vue&type=style&index=0&id=31c59304&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c59304",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTimeline } from 'vuetify/lib/components/VTimeline';
import { VTimelineItem } from 'vuetify/lib/components/VTimeline';
installComponents(component, {VCard,VCardText,VChip,VCol,VRow,VTimeline,VTimelineItem})
